export default __webpack_public_path__ + "static/media/cometa_negro.a0c5a1ce.png";